import React from 'react';
import * as Styles from './CtaButton.styles';

const CtaButton = ({ onClick, children }) => (
  <Styles.Button onClick={onClick} type="button">
    {children}
  </Styles.Button>
);

export default CtaButton;
